import RequestChannelController from './channel';

export default class RequestChannelUploads extends RequestChannelController {}
